import { FormatPrice, formatPrice } from '@ibe/services';

const CHF_GROUP_SEPARATOR = "'";

export const formatTHGPrice: FormatPrice = (
  amount,
  currencyCode,
  locale,
  removeZeroDecimals,
  useGrouping = true,
  currencyDisplay,
  currencyFirst,
  removeDecimalsAndRound
) => {
  if (currencyCode !== 'CHF') {
    return formatPrice(
      amount,
      currencyCode,
      locale,
      removeZeroDecimals,
      useGrouping,
      currencyDisplay,
      currencyFirst,
      removeDecimalsAndRound
    );
  }

  const digits = amount % 1 === 0 ? 0 : 2;

  const parts = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    currencyDisplay: (currencyDisplay ?? 'symbol') as Intl.NumberFormatOptions['currencyDisplay'],
    useGrouping: true,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
    .formatToParts(amount)
    .map(p => (p.type === 'group' ? { ...p, value: CHF_GROUP_SEPARATOR } : p));

  if (currencyFirst) {
    const currency = parts.find(p => p.type === 'currency')?.value ?? '';
    const rest = parts
      .filter(p => p.type !== 'currency' && p.type !== 'literal')
      .map(p => p.value)
      .join('');
    return `${currency} ${rest.trim()}`;
  }

  return parts
    .map(p => p.value)
    .join('')
    .replaceAll('\u00A0', ' ');
};

export default formatTHGPrice;
